import apiClient from './client'

export interface DashboardStats {
  persons: number
  biodata: number
  photos: number
  media_release_forms: number
}

export const dashboardApi = {
  getStats: async (): Promise<DashboardStats> => {
    const { data } = await apiClient.get('/dashboard/stats')
    return data
  },
}
